// src/layouts/authentication/components/BasicLayout.jsx
import React from 'react';
import { Box, Container } from '@mui/material';

function BasicLayout({ children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Container maxWidth="sm">
        {children}
      </Container>
    </Box>
  );
}

export default BasicLayout;